import { Controller } from '@hotwired/stimulus';
import Cookies from 'js-cookie';
import { scrollLock } from '../utils/scrollLock';
/*
 * Description
 * -------
 *
 * Handles modal.
 * Can be used on any element.
 * Can be used multiple times in the document.
 *
 * Values
 * -------
 *
 * open       - (optional) - whether the modal should be open on page load
 * cookieName - (optional) - the name of the cookie to set when the modal is closed
 *
 * Usage
 * -------
 *
 * <div class="hidden" data-controller="modal">
 *   <div data-action="click->modal#open"></div>
 *   <div class="modal" data-modal-target="container">
 *     <div data-action="click->modal#close">Close</div>
 *   </div>
 * </div>
 */
export default class default_1 extends Controller {
    static targets = ['container'];
    static values = {
        open: { type: Boolean, default: false },
        cookieName: { type: String },
    };
    connect() {
        if (this.openValue)
            this.open();
    }
    close() {
        scrollLock('remove');
        this.containerTarget.classList.add('hidden');
        if (this.cookieNameValue)
            Cookies.set(this.cookieNameValue, 'true', { expires: 7 });
        if (this.focusedElement && window.__fw_app__.tvSession)
            this.focusedElement.focus();
    }
    open() {
        scrollLock('add');
        this.containerTarget.classList.remove('hidden');
        if (window.__fw_app__.tvSession) {
            this.focusedElement = document.activeElement;
            this.containerTarget.querySelector('[data-tv-focusable]')?.focus();
        }
    }
    documentMorph() {
        this.close();
    }
}
